import React from 'react';

const authContext = React.createContext({
    keycloak_adapter: null
});

export default authContext;